<template>
    <div class="upload-image">
        <h3>{{ this.text }}</h3>
        <Vue2Dropzone
            ref="imgDropzone"
            id="dropzone"
            :style="dropzoneStyle"
            :options="dropzoneOptions"
            useCustomSlot
            @vdropzone-complete="storageUpload"
        >
            <div v-if="img"/>
            <span v-else>Drop an image here or click to upload</span>
        </Vue2Dropzone>
    </div>
</template>

<script>
import Vue2Dropzone from 'vue2-dropzone'

export default {
    name: 'UploadImage',
    props: {
        'storageRef': {required: true},
        'img': {required: true},
        'text': {default: ''},
        'borderRadius': {default: '400px'},
    },
    components: {
        Vue2Dropzone,
    },
    data() {
        return {
            dropzoneOptions: {
                url: "https://httpbin.org/post",
                maxFilesize: 5,
                thumbnailWidth: 200,
                thumbnailHeight: 200,
                addRemoveLinks: false,
                acceptedFiles: ".jpg, .jpeg, .png, .svg"
            }
        }
    },
    computed: {
        dropzoneStyle() {
            return {
                backgroundImage: 'url(' + this.img + ')',
                borderRadius: this.borderRadius,
            }
        }
    },
    methods: {
        async storageUpload(upload) {
            this.isLoading = true
            try {
                let file = upload
                var metadata = {
                    contentType: file.contentType
                }
                await this.storageRef.put(file, metadata)
                var downloadURL = await this.storageRef.getDownloadURL()

                var newImg = {
                    img: downloadURL
                }
                this.$emit('updateImg', newImg)
            } catch (error) {
                console.log(error)
            } finally {
                this.$refs.imgDropzone.removeAllFiles()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../dropzone.scss';

.upload-image {
    margin: 0 auto 50px auto;
    width: 200px;
    h3 {
        margin-top: 0;
        text-align: center;
    }
}

.dropzone {
    margin: 0;
    padding: none;
    width: 200px;
    height: 200px;
    position: relative;

    font: inherit;
    font-weight: bold;
    color: black;

    background-color: white;
    background-size: 200px;
    box-shadow: 0 0 0 4px var(--main-color);
    overflow: hidden;
    border: none;

    &:hover {
        box-shadow: 0 0 0 8px var(--main-color);
        background-color: black;
        color: white;
    }
}
</style>